// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Declare once – keep outside component so it isn’t re-allocated on each render
const NAV_ITEMS = [
  { path: '/', label: 'Home' },
  // { path: '/music', label: 'Music' },
  // { path: '/fun', label: 'Fun' },
  // { path: '/projects', label: 'Projects' },
  // { path: '/robotics', label: 'Robotics' },
  { path: '/experiments', label: 'Experiments' },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAnalytics, setShowAnalytics] = useState(false);

  // Decide whether the Analytics link should be shown. It is visible:
  //   • In development builds (NODE_ENV !== 'production')
  //   • When a valid analytics authentication token exists in localStorage
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      setShowAnalytics(true);
      return;
    }

    try {
      const token = localStorage.getItem('analytics_auth');
      const time = localStorage.getItem('analytics_auth_time');

      if (token && time) {
        const hours = (Date.now() - parseInt(time, 10)) / (1000 * 60 * 60);
        if (hours < 24) {
          setShowAnalytics(true);
        }
      }
    } catch {
      // Access to localStorage might fail in SSR – ignore silently.
    }
  }, []);

  const toggleMenu = () => setIsMenuOpen((open) => !open);

  const MenuLinks = ({ isMobile = false }) => {
    // Construct the nav list dynamically so we can optionally add Analytics.
    const items = [...NAV_ITEMS];
    if (showAnalytics) {
      items.push({ path: '/analytics', label: 'Analytics' });
    }

    return (
      <ul
        className={
          isMobile
            ? 'flex flex-col space-y-4 mt-4'
            : 'hidden md:flex justify-end space-x-10'
        }
      >
        {items.map(({ path, label }) => (
          <li key={path}>
            <Link
              to={path}
              onClick={isMobile ? toggleMenu : undefined}
              className="text-primary text-l hover:text-secondary font-bold block"
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <nav className="p-4 sticky top-0 z-10 bg-background">
      {/* Mobile hamburger button */}
      <div className="md:hidden flex justify-end">
        <button
          onClick={toggleMenu}
          className="text-primary focus:outline-none"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          {isMenuOpen ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <MenuLinks isMobile />}

      {/* Desktop menu */}
      <MenuLinks />
    </nav>
  );
};

export default Navbar;
